import { FormData } from '../forms-ui-form-faas.interface';
import * as MetadataProcessor from './metadata-processor/iFormMetaDataProcessor';
import { IFaaSDataClient } from '../api/faas-data';
import { processFormMetadata } from './metadata-processor/processFormMetadata';
import { CountryProcessor } from './metadata-processor/countryProcessor';
import { PrepopulatedFieldProcessor } from './metadata-processor/prepopulatedFieldProcessor';
import { ProductHierarchyProcessor } from './metadata-processor/productHierarchyProcessor';

export interface IMetadataRetriever {
  getFormMetadata(): Promise<FormData>
}

export class MetadataRetriever implements IMetadataRetriever {
	private client: IFaaSDataClient;

	private processors: MetadataProcessor.IFormMetadataProcessor[];

	constructor(
		faasDataClient: IFaaSDataClient,
		processors: MetadataProcessor.IFormMetadataProcessor[],
	) {
		this.client = faasDataClient;
		this.processors = processors;
	}

	/** Retrieve form metadata from the faas API. If debug is true, returns a hardcoded form metadata. */
	async getFormMetadata(): Promise<FormData> {
		const formMetadata = await this.client.getFormMetadata();
		return processFormMetadata(formMetadata, this.processors);
	}
}

/* istanbul ignore next */
export function createMetadataRetriever(faasDataClient: IFaaSDataClient): IMetadataRetriever {
	const processors = [
		new CountryProcessor(),
		new ProductHierarchyProcessor(),
		new PrepopulatedFieldProcessor(),
	];

	return new MetadataRetriever(faasDataClient, processors);
}
